document.addEventListener("DOMContentLoaded", function () {
  AOS.init();
  if (document.getElementsByClassName("splide").length != 0) {
    var splide = new Splide(".splide", {
      type: "loop",
      perPage: 5,
      pagination: false,
      drag   : 'free',
      focus  : 'center',
      breakpoints: {
        1024: {
          perPage: 1,
        },
      },
      autoScroll: {
        speed: 1,
      },
      autoplay: true,
      rewind: false, 
    });
    splide.mount(window.splide.Extensions);

  }

  //changing the meny bar
  let options = {
    //root: null, //document.querySelector("#main-menu"),
    rootMargin: "0px",
    threshold: [0.3],
  };

  let observer = new IntersectionObserver(callback, options);

  let targets = document.querySelectorAll(".growing-line");
  for (var target of targets) {
    //console.log("observe: ", target);
    observer.observe(target);
  }
  let home = document.querySelector("#topo-home");
  if (home) {
    observer.observe(home);
  }

  let about_image = document.querySelector(".about-image");
  if (about_image) {
    observer.observe(about_image);
  }

  let topo_main = document.querySelector("#topo-main");
  if (topo_main) {
    observer.observe(topo_main);
  }
  let topo_wizard = document.querySelector("#topo-wizard");
  if (topo_wizard) {
    observer.observe(topo_wizard);
  }

  //observer.observe(document.querySelector("#tradycja"));

  jQuery(".navbar-burger").on("click", menu_selected);
  jQuery(".navbar-menu").on("click", menu_selected);
  jQuery(".topo-add-to-cart").on("click", topo_add_to_cart);

  // required to refresh woocommerce notices for OceanWP ajax add to cart.
  jQuery("body").on("added_to_cart", function (e) {
    //console.log(e);
    //alert('added'+e);
  });
});

const menu_selected = (event) => {
  const hamburger = jQuery(event.currentTarget).hasClass("navbar-burger");
  const nav = jQuery(".navbar-menu");
  const kids = jQuery(".navbar-burger").children();
  //console.log("menu_selected");
  const langSwitch = jQuery(event.target).parents('.wpml-floating-language-switcher').length;
  //console.log('lang', langSwitch);
  if(langSwitch>0) return;
  if (nav.hasClass("opacity-0")) {
    if (hamburger) {
      nav
        .removeClass("opacity-0")
        .addClass("opacity-80")
        .removeClass("translate-x-full")
        .addClass("translate-x-0");
      kids.each(function (i) {
        const className = "line" + (i + 1);
        jQuery(this).addClass(className);
      });
    }
  } else {
    nav
      .removeClass("opacity-80")
      .addClass("opacity-0")
      .removeClass("translate-x-0")
      .addClass("translate-x-full");
    kids.each(function (i) {
      const className = "line" + (i + 1);
      jQuery(this).removeClass(className);
    });
  }
};

let callback = (entries, observer) => {
  entries.forEach((entry) => {
    //console.log("callback;", entry.target);
    if (entry.isIntersecting) {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-0").removeClass("opacity-100");
          break;
        case "topo-home":
          jQuery(".nav-mobile").addClass("").removeClass("bg-black opacity-80");
          //console.log("nasze_miody in");
          break;
        case "about-image":
          jQuery(".about-image")
            .addClass("")
            .removeClass("grayscale brightness-75");
          break;
        case "topo-main":
          jQuery("#desktop-menu")
            .removeClass("bg-black")
            .addClass("bg-transparent");
          break;
        case "topo-wizard":
          jQuery("#desktop-menu").addClass("bg-black").removeClass("bg-transparent");;

          break;

        default:
          jQuery("#desktop-menu").addClass("bg-black").removeClass("bg-transparent");
          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-full")
            .removeClass("w-0");
      }
    } else {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-100").removeClass("opacity-0");
          break;
        case "topo-home":
          jQuery(".nav-mobile").addClass("bg-black opacity-80").removeClass("");

          //console.log("nasze_miody out");
          break;
        case "about-image":
          jQuery(".about-image")
            .addClass("grayscale brightness-75")
            .removeClass("");
          break;
        case "topo-main":
          jQuery("#desktop-menu")
            .removeClass("bg-transparent")
            .addClass("bg-black");
          break;
        case "topo-wizard":
          jQuery("#desktop-menu").addClass("bg-black").removeClass("bg-transparent");;

          break;
        default:
          jQuery("#desktop-menu").addClass("bg-black").removeClass("bg-transparent");;

          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-0")
            .removeClass("w-full");
      }
    }

    // Each entry describes an intersection change for one observed
    // target element:
    //   entry.boundingClientRect
    //   entry.intersectionRatio
    //   entry.intersectionRect
    //   entry.isIntersecting
    //   entry.rootBounds
    //   entry.target
    //   entry.time
  });
};

const topo_add_to_cart = (event) => {
  //console.log(event.currentTarget.dataset.productid);
  // console.log(
  //   "topo_add_to_cart:",
  //   jQuery(".topo-add-to-cart").data("productid")
  // );
  //alert("clicked");
  topo_AddToCart(event.currentTarget.dataset.productid);
};

function topo_AddToCart(product_id, quantity = 1) {
  // let's check is add-to-cart.min.js is enqueued and parameters are presented
  if ("undefined" === typeof wc_add_to_cart_params) {
    return false;
  }

  jQuery.post(
    wc_add_to_cart_params.wc_ajax_url
      .toString()
      .replace("%%endpoint%%", "add_to_cart"),
    {
      product_id: product_id,
      quantity: quantity, // quantity is hardcoced her
    },
    function (response) {
      if (!response) {
        return;
      }
      // redirect is optional and it depends on what is set in WooCommerce configuration
      if (response.error && response.product_url) {
        console.log("topo_AddToCart, response:", response.error);
        //window.location = response.product_url;
        return;
      }
      console.log(response);
      if ("yes" === wc_add_to_cart_params.cart_redirect_after_add) {
        window.location = wc_add_to_cart_params.cart_url;
        return;
      }
      //reload instead of adjusting cart with event becasue in 9.3.1 it stopped working
      window.location.reload();

      // refresh cart fragments etc
      jQuery(document.body).trigger("added_to_cart", [
        response.fragments,
        response.cart_hash,
      ]);
      jQuery(".wc-block-mini-cart__button").addClass("animate-bounce");
    }
  );
}
